
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/[...slugs]",
      function () {
        return require("private-next-pages/learn/[...slugs].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/[...slugs]"])
      });
    }
  